import {
  ACT_INSTANCES_FETCH_CHARACTERISTICS_INIT_ACTION,
  ACT_INSTANCES_FETCH_CHARACTERISTICS_SUCCESS_ACTION,
  ACT_INSTANCES_GET_CHARACTERISTIC_INIT_ACTION,
  ACT_INSTANCES_GET_CHARACTERISTIC_SUCCESS_ACTION,
  ACT_INSTANCES_ADD_CHARACTERISTIC_INIT_ACTION,
  ACT_INSTANCES_ADD_CHARACTERISTIC_SUCCESS_ACTION,
  ACT_INSTANCES_DELETE_CHARACTERISTIC_INIT_ACTION,
  ACT_INSTANCES_DELETE_CHARACTERISTIC_SUCCESS_ACTION,
  ACT_INSTANCES_UPDATE_CHARACTERISTIC_FILTERS,
  ACT_INSTANCES_SET_SELECTED_CHARACTERISTIC,
} from '../../constants/actions';

export const fetchCharacteristicsInitAction = () => ({
  type: ACT_INSTANCES_FETCH_CHARACTERISTICS_INIT_ACTION,
});

export const fetchCharacteristicsSuccessAction = data => ({
  type: ACT_INSTANCES_FETCH_CHARACTERISTICS_SUCCESS_ACTION,
  payload: data,
});

export const getCharacteristicInitAction = () => ({
  type: ACT_INSTANCES_GET_CHARACTERISTIC_INIT_ACTION,
});

export const getCharacteristicSuccessAction = data => ({
  type: ACT_INSTANCES_GET_CHARACTERISTIC_SUCCESS_ACTION,
  payload: data,
});

export const addCharacteristicInitAction = data => ({
  type: ACT_INSTANCES_ADD_CHARACTERISTIC_INIT_ACTION,
  payload: data,
});

export const addCharacteristicSuccessAction = data => ({
  type: ACT_INSTANCES_ADD_CHARACTERISTIC_SUCCESS_ACTION,
  payload: data,
});

export const deleteCharacteristicInitAction = id => ({
  type: ACT_INSTANCES_DELETE_CHARACTERISTIC_INIT_ACTION,
  payload: id,
});

export const deleteCharacteristicSuccessAction = () => ({
  type: ACT_INSTANCES_DELETE_CHARACTERISTIC_SUCCESS_ACTION,
});

export const updateCharacteristicsFiltersAction = filters => ({
  type: ACT_INSTANCES_UPDATE_CHARACTERISTIC_FILTERS,
  payload: filters,
});

export const updateSelectedCharacteristicAction = Characteristic => ({
  type: ACT_INSTANCES_SET_SELECTED_CHARACTERISTIC,
  payload: Characteristic,
});
